module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/340d9d4db94c4557ddcc7bbe6e39e4ce.png";